import React, { useEffect, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import useFileDocuments from "../actions/useFileDocuments";
import SearchFIles from "./SearchFIles";
import CustomeButton from "~/components/Button";
import { useSelector } from "react-redux";
import FolderListSection from "~/components/folder-list-section/FolderListSection";

const ProcessFileDocuments = () => {
  const { id, service_id, process_id, type } = useParams();
  const location = useLocation();
  const {
    states,
    fileName,
    setFileName,
    processName,
    rows,
    first,
    onPageChange,
    handleOpenProcess,
    handleClickPayslip,
    handleCategoryFolderClick,
    setSelectedCategory,
  } = useFileDocuments({ id, service_id, type, process_id });
  const { blobFilterStates } = useSelector((state) => state.attachments);

  // Auto-select category folder when navigating from "View in Folder"
  const appliedCategoryRef = useRef(false);
  useEffect(() => {
    const categoryCode = location.state?.categoryCode;
    if (
      !categoryCode ||
      appliedCategoryRef.current ||
      states?.categoryFoldersLoading ||
      !states?.folders?.length
    )
      return;
    const matchingFolder = states.folders.find(
      (f) => f.isCategoryFolder && f.code === categoryCode,
    );
    if (matchingFolder) {
      appliedCategoryRef.current = true;
      setSelectedCategory(matchingFolder);
    }
  }, [location.state, states?.folders, states?.categoryFoldersLoading]);

  const isCoreEntityPersonView =
    states?.selectedService?.name === "Core Entity Information" &&
    process_id &&
    states?.selectedType;

  const isProcessFolderView =
    process_id &&
    states?.selectedService?.isProcess &&
    states?.selectedProcess &&
    states?.selectedService?.name !== "Core Entity Information";

  const showCategoryFolders =
    (isCoreEntityPersonView || isProcessFolderView) &&
    !states?.selectedCategory;
  const showCategoryFilteredTable =
    (isCoreEntityPersonView || isProcessFolderView) && states?.selectedCategory;

  return (
    <>
      {states?.selectedService?.name === "Payroll" && !isProcessFolderView && (
        <FolderListSection
          folders={states?.folders}
          loading={states.loading}
          onFolderClick={handleClickPayslip}
          hideSkeletonOnFilter={false}
        />
      )}
      {showCategoryFolders && (
        <FolderListSection
          folders={states?.folders}
          loading={states.loading || states?.categoryFoldersLoading}
          isFilterApplied={false}
          onFolderClick={handleCategoryFolderClick}
          showEmptyState={true}
          emptyMessage="No files here yet"
        />
      )}
      {showCategoryFilteredTable && (
        <SearchFIles
          fileName={fileName}
          setFileName={setFileName}
          additionaltag={{ entity: [states?.entity_detail?.name] }}
          states={states}
          processName={processName}
          first={first}
          rows={rows}
          onPageChange={onPageChange}
          categoryFilter={states?.selectedCategory}
        />
      )}
      {!states.loading &&
        !showCategoryFolders &&
        !showCategoryFilteredTable && (
          <>
            {states?.selectedProcess?.isProcess && (
              <CustomeButton
                onClick={handleOpenProcess}
                label="Open Process"
                className="cancel-btn ml-auto mb-3"
                icon="pi pi-external-link"
                iconPos="right"
              />
            )}
            <p className="document-sub-heading">
              {blobFilterStates?.selectedItems?.length
                ? "Matching Files"
                : null}
            </p>
            <SearchFIles
              fileName={fileName}
              setFileName={setFileName}
              additionaltag={{ entity: [states?.entity_detail?.name] }}
              states={states}
              processName={processName}
              first={first}
              rows={rows}
              onPageChange={onPageChange}
            />
          </>
        )}
    </>
  );
};

export default ProcessFileDocuments;
